export const AppURL = {
    About: 'about',
    Terms: 'terms',
    Policy: 'policy',
    Login: 'login',
    MainPage: '',
    Site: 'site',
    HospitalDetail: 'hospital',
    ServiceDetail: 'service',
    UserDetail: 'user'
};
